import symbolData from '../translation/currency-formatting/cldr-currency-symbols-data.json';
import {injectable} from "inversify";
interface ICurrencySymbol{
    displayName: string;
    symbol: string;
    'symbol-alt-narrow'?: 'string';
}
@injectable()
export default class CurrencyService{
    getCurrencySymbol (code: string) {
        const currencyObj = symbolData.main.en.numbers.currencies as {[key: string]: ICurrencySymbol};
        const currencyKey = Object.keys(currencyObj).find((c) => {
            return c === code;
        });
        if(currencyKey === undefined){
            return code;
        }
        const currency = currencyObj[currencyKey];
        return currency["symbol-alt-narrow"] || currency["symbol"];
    }

    formatCurrency(amount: number, currencyCode: string): string {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
            roundingMode: 'trunc',
        }).format(amount);
    }
}